import { Alert, Divider, Skeleton } from '@chakra-ui/react';
import React, { useState } from 'react';

import { GraphProvider } from '../hooks/bbplMonitorContext';
import { StatusProvider } from '../hooks/bbplStatusContext';
import { BBPLMonitorParams } from '../types/bbplMonitorTypes';
import { BBPLMonitorOptionalDrawer } from './BBPLMonitorDrawer';
import { BBPLMonitorOptions } from './BBPLMonitorOptions';
import { GraphRenderer } from './GraphRenderer';

type Props = { creditFacilityId: string };
export const BBPLMonitorForCreditFacility = ({ creditFacilityId }: Props) => {
  const [
    graphParams,
    setBbplMonitorParams,
  ] = useState<BBPLMonitorParams | null>(null);

  return (
    <StatusProvider
      creditFacilityId={creditFacilityId}
      placeHolder={<Skeleton />}
    >
      <BBPLMonitorOptions
        initialParams={graphParams}
        onChange={setBbplMonitorParams}
      />

      {graphParams && (
        <GraphProvider params={graphParams}>
          <GraphRenderer />
          <BBPLMonitorOptionalDrawer />
        </GraphProvider>
      )}
      <Divider />

      {!graphParams && <Alert>No Graph to display!</Alert>}
    </StatusProvider>
  );
};
